import { ReactNode } from 'react';
import styled from 'styled-components';

import { UnstyledButton } from '@components/UnstyledButton/UnstyledButton';

type ChipSelectOptionProps = {
  className?: string;
  isSelected: boolean;
  label: ReactNode;
  onClick: () => void;
};
export const ChipSelectOption = ({
  className,
  isSelected,
  label,
  onClick,
}: ChipSelectOptionProps) => {
  return (
    <StyledButton
      isSelected={isSelected}
      onClick={onClick}
      className={
        className ? `chip-select-option ${className}` : 'chip-select-option'
      }
    >
      {label}
    </StyledButton>
  );
};

type StyledButtonProps = {
  isSelected: boolean;
};
const StyledButton = styled(UnstyledButton)<StyledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.palette.stroke[6] : '#FFFFFF'};

  border: 1px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.palette.primary[0] : theme.palette.stroke[0]};

  border-radius: 100px;
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.palette.primary[0] : theme.palette.text[0]};
`;
